var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z",
    stroke: "#818999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 16.875C12.125 16.944 12.069 17 12 17C11.931 17 11.875 16.944 11.875 16.875C11.875 16.806 11.931 16.75 12 16.75C12.069 16.75 12.125 16.806 12.125 16.875Z",
    fill: "#818999",
    stroke: "#818999",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5004V12.7504C12.5192 12.7504 13.0267 12.5964 13.4584 12.308C13.8901 12.0195 14.2265 11.6096 14.4252 11.1299C14.6239 10.6503 14.6759 10.1225 14.5746 9.61325C14.4733 9.10405 14.2233 8.63632 13.8562 8.26921C13.489 7.9021 13.0213 7.65209 12.5121 7.55081C12.0029 7.44952 11.4751 7.5015 10.9955 7.70018C10.5158 7.89886 10.1058 8.23532 9.81739 8.66699C9.52895 9.09867 9.375 9.60619 9.375 10.1254",
    stroke: "#818999",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuestion);
export default __webpack_public_path__ + "static/media/ico-question.da54f1b7.svg";
export { ForwardRef as ReactComponent };